import { createSlice } from "@reduxjs/toolkit";
import { sendOTP, resendOTP, verifyOTP, verifyTestOTP, logoutUser, refreshToken, verifyMPIN } from "./loginActions";

const initialState = {
   loading: false,
   loginMode: null,
   userInfo: {},
   accessToken: null,
   userId: null,
   error: null,
   message: null,
   success: null,
   isProfileCreated: null,
   status: null,
   isLogout: false,
   loginPopUp: false,
   verifyingData: null,
   verificationSuccess: false,
   verificationError: null,

}

const loginSlice = createSlice({
   name: "login",
   initialState,
   reducers: {
      updateLoginMode: (state, { payload }) => {
         state.loginMode = payload;
      },
      loginPopupHandler: (state, { payload }) => {
         state.loginPopUp = payload;
      },
      // Test-login: the QA number skips the real send-OTP call, so populate the
      // bits the OTP screen needs (mobileNo / countryCode via userInfo) directly.
      setTestLogin: (state, { payload }) => {
         state.loading = false;
         state.success = true;
         state.userInfo = payload;
      },
      clearLogin: () => initialState,
   },
   extraReducers: (builder) => {
      // Mobile send OTP
      builder.addCase(sendOTP.pending, (state) => {
         state.loading = true
      })
      builder.addCase(sendOTP.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success";
         state.userInfo = payload?.data
      })
      builder.addCase(sendOTP.rejected, (state, { payload }) => {

         state.error = true
      })

      // Resend OTP
      builder.addCase(resendOTP.pending, (state) => {
         state.loading = true
      })
      builder.addCase(resendOTP.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success";
      })
      builder.addCase(resendOTP.rejected, (state, { payload }) => {

         state.error = true
      })

      // Verify OTP
      builder.addCase(verifyOTP.pending, (state) => {
         state.loading = true
      })
      builder.addCase(verifyOTP.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success";
         state.userId = payload?.response?.data?.data?.item?.userId;
         state.accessToken = payload?.response?.data?.data?.item?.auth?.accessToken
         state.isProfileCreated = payload?.response?.data?.data?.item?.isProfileCreated || payload?.response?.data?.data?.item?.loginMode === 'admin';
         state.loginMode = payload?.response?.data?.data?.item?.loginMode
         if (payload?.response?.data?.data?.item?.loginMode) {
            localStorage.setItem(
               "loginMode",
               payload?.response?.data?.data?.item?.loginMode
            );
         }
      })
      builder.addCase(verifyOTP.rejected, (state, { payload }) => {

         state.error = true
         state.success = payload?.response?.data?.status?.type === "success";
         state.status = payload?.status
      })

      // Verify Test OTP (QA number), same state shape as verifyOTP
      builder.addCase(verifyTestOTP.pending, (state) => {
         state.loading = true
      })
      builder.addCase(verifyTestOTP.fulfilled, (state, { payload }) => {

         state.loading = false
         state.success = payload?.response?.data?.status?.type === "success";
         state.userId = payload?.response?.data?.data?.item?.userId;
         state.accessToken = payload?.response?.data?.data?.item?.auth?.accessToken
         state.isProfileCreated = payload?.response?.data?.data?.item?.isProfileCreated || payload?.response?.data?.data?.item?.loginMode === 'admin';
         state.loginMode = payload?.response?.data?.data?.item?.loginMode
         if (payload?.response?.data?.data?.item?.loginMode) {
            localStorage.setItem(
               "loginMode",
               payload?.response?.data?.data?.item?.loginMode
            );
         }
      })
      builder.addCase(verifyTestOTP.rejected, (state, { payload }) => {

         state.error = true
         state.success = payload?.response?.data?.status?.type === "success";
         state.status = payload?.status
      })

      // Logout User
      builder.addCase(logoutUser.pending, (state) => {
         state.loading = true
         state.isLogout = false;
      })
      builder.addCase(logoutUser.fulfilled, (state, { payload }) => {

         state.loading = false
         state.isLogout = payload?.response?.data?.status?.type === "success";
      })
      builder.addCase(logoutUser.rejected, (state, { payload }) => {

         state.error = true
         state.isLogout = true
      })

      // RefreshToken
      builder.addCase(refreshToken.pending, (state) => {
         state.loading = true
         state.isLogout = false;
      })
      builder.addCase(refreshToken.fulfilled, (state, { payload }) => {

         state.loading = false
         state.accessToken = payload?.response?.data?.data?.item?.auth?.accessToken
      })
      builder.addCase(refreshToken.rejected, (state, { payload }) => {

         state.error = true
      })

      builder
         .addCase(verifyMPIN.pending, (state) => {
            state.verifyingData = null;
            state.verificationSuccess = false;
            state.verificationError = null;
         })
         .addCase(verifyMPIN.fulfilled, (state, action) => {

            state.verifyingData = action.payload?.response || null;
            state.verificationSuccess = true;
            state.verificationError = null;
         })
         .addCase(verifyMPIN.rejected, (state, action) => {
            state.verifyingData = null;
            state.verificationSuccess = false;
            state.verificationError = action.payload || "Verification failed";
         });
   }
})

export const { updateLoginMode, clearLogin, loginPopupHandler, setTestLogin } = loginSlice.actions;

export default loginSlice.reducer